<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品添加
    -->
  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px" v-if="!loading">
      <!--基础信息-->
      <Basic></Basic>

      <!--规格设置-->
      <Spec></Spec>

      <!--商品详情-->
      <Content></Content>

      <!--商品活动-->
      <Activity></Activity>

      <!--高级设置-->
      <Buyset></Buyset>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :disabled="save_loading">发布</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Basic from './part/Basic.vue';
import Spec from './part/Spec.vue';
import Content from './part/Content.vue';
import Buyset from './part/Buyset.vue';
import Activity from './part/Activity.vue';
import { formatModel } from '@/utils/base.js';
export default {
  components: {
    /*基础信息*/
    Basic,
    /*规格信息*/
    Spec,
    /*商品详情*/
    Content,
    /*高级设置*/
    Buyset,
    /*活动设置*/
    Activity,
  },
  data() {
    return {
      /*商品ID*/
      product_id: 0,
      /*判断是编辑*/
      scene: 'edit',
      /*是否正在加载*/
      loading: true,
      /*是否正在提交保存*/
      save_loading: false,
      /*form表单数据*/
      form: {
        model: {},
        /*标签*/
        label: [],
        /*商品分类*/
        catgory: [],
        /*运费模板*/
        delivery: [],
        /*会员等级*/
        gradeList: [],
        supplierList: [],
        /*规格数据*/
        specData: null,
        /*是否锁住*/
        isSpecLocked: false,
        /*是否锁住活动类型*/
        isTypeLocked: false,
        /*分销基础设置*/
        basicSetting: {},
      },
      /*模型数据*/
      model: {
        /*商品名称*/
        product_name: '',
        /*商品编码*/
        product_no: '',
        /*商品分类*/
        category_id: null,
        /*商品图片*/
        image: [],
        /*商品卖点*/
        selling_point: '',
        /*规格类别,默认10单规格，20多规格*/
        spec_type: 10,
        /*库存计算方式,默认20付款减库存，10下单减库存*/
        deduct_stock_type: 20,
        /*检查用户等级*/
        is_alone_grade: 0,
        /*活动类型 0 视频 1 活动 2普通*/
        is_line:0,
        /*是否关联课程 0 否 1 是*/
        is_course:1,
        /*活动数据*/
        active:{
          active_time:'',
          name:'',
          address:'',
          mobile:'',
          dec:'',
          number:1,
          coordinate:'',
        },
        /*课程*/
        course:'',
        /*单规格*/
        sku: {
          /*产品价格*/
          product_price: 0,
          /*产品划线价*/
          line_price: 0,
          /*库存数量*/
          stock_num: 0,
          /*商品重量*/
          product_weight: 0
        },
        /*多规格类别*/
        spec_many: {
          /*多规格类别*/
          spec_attr: [],
          /*多规格表格数据*/
          spec_list: []
        },
        /*商品购买权限,默认为关闭 0 开启为1*/
        buy_limit: 0,
        /*购买权限详情*/
        buy_auth:[],
        /*商品详情内容*/
        content: '',
        /*运费模板ID*/
        delivery_id: '',
        /*商品状态*/
        product_status: 10,
        /*初始销量*/
        sales_initial: 0,
        /*商品排序，默认100*/
        product_sort: 100,
        /*是否开启积分赠送,默认1为开启，0为关闭*/
        is_points_gift: 1,
        /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
        is_points_discount: 1,
        /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
        is_enable_grade: 1,
        /*等级金额类型,默认10为百分比，20为固定金额*/
        alone_grade_type: 10,
        /*是否开启单独分销,默认0为关闭，1为开启*/
        is_ind_agent: 0,
        /*分销佣金类型,默认10为百分比，20为固定金额*/
        agent_money_type: 10,
        /*积分抵扣类型,默认10为百分比，20为固定金额*/
        alone_credit_type:10,
        /*分销类型 0 统一 1 按等级*/
        commission_type:0,
        /*一级佣金*/ 
        first_money: 0,
        /*二级佣金*/
        second_money: 0,
        /*三级佣金*/
        third_money: 0,
        /*代理极差设置,默认0为关闭，1为开启*/
        is_alone_enable_grade_equity:0,
        /*是否虚拟商品*/
        is_virtual: 0,
        /*升级的等级*/
        up_grade_id: '',
        supplier_id: '',
        /*限购数量*/
        buy_limit_num: 0,
        /*积分抵扣*/
        points_discount: 0,
        buy_total_num: 0, //累计限购
        label_id: [],  //标签集合
        is_recommend: false,  //推荐
        is_hot: false, // 热卖
        is_new: false, //新品
        poster: '',//视频封面
        video: '',//视频
        skucate:[],// sku 分类
      }
    };
  },
  provide: function() {
    return {
      form: this.form
    };
  },
  created() {
    /*获取列表*/
    this.product_id = this.$route.query.product_id;
    this.scene = this.$route.query.scene;
    this.getData();
  },
  methods: {
    /**
     * 获取基础数据
     */
    getData: function() {
      let self = this;
      PorductApi.getEditData(
        {
          product_id: self.product_id,
          scene: self.scene
        },
        true
      )
        .then(res => {
          self.loading = false;
          /*单独产品分销*/
          if(res.data.model.alone_money_equity!=null&&typeof res.data.model.alone_money_equity !='undefined' &&res.data.model.alone_money_equity!=''){
            let moneys=res.data.model.alone_money_equity;
            res.data.gradeList.forEach(item=>{
              self.$set(item, 'first_money',moneys['first_money'][item.grade_id]?moneys['first_money'][item.grade_id]:0)
              self.$set(item, 'second_money',moneys['second_money'][item.grade_id]?moneys['second_money'][item.grade_id]:0)
              self.$set(item, 'third_money',moneys['third_money'][item.grade_id]?moneys['third_money'][item.grade_id]:0)

            });
          }else{
            res.data.gradeList.forEach(item=>{
              self.$set(item, 'first_money', 0)
              self.$set(item, 'second_money', 0)
              self.$set(item, 'third_money',0)
            });
          }
          /*代理极差折扣*/
          if(res.data.model.alone_enable_grade_equity!=null&&typeof res.data.model.alone_enable_grade_equity !='undefined'){
            let equallys=res.data.model.alone_enable_grade_equity;
            res.data.gradeList.forEach(item=>{
              item.push=equallys[item.grade_id];
            });
          }
          /*单独产品折扣*/
          if(res.data.model.alone_grade_equity!=null&&typeof res.data.model.alone_grade_equity !='undefined'){
            let equitys=res.data.model.alone_grade_equity;
            res.data.gradeList.forEach(item=>{
              item.product_equity=equitys[item.grade_id];
            });
          }
          Object.assign(self.form, res.data);
          self.$set(self.model, 'buy_limit',res.data.model.buy_limit);
          if(!res.data.model.buy_auth){
            self.$set(self.model,'buy_auth',[]);
          }else{
            self.$set(self.model,'buy_auth',res.data.model.buy_auth);
          }
          let label = [];
          res.data.model.labels.forEach(item=>{
              label.push(item.id);
            });
          self.form.model.label_id = label;

          self.form.model.is_hot = self.form.model.is_hot == 1 ? true: false;
          self.form.model.is_recommend = self.form.model.is_recommend == 1 ? true: false;
          self.form.model.is_new = self.form.model.is_new == 1 ? true: false;

          if (res.data.specData) {
            self.$set(self.form.model, 'spec_many', res.data.specData);
          } else {
            self.$set(self.form.model, 'spec_many', {
              spec_attr: [],
              spec_list: []
            });
            self.form.model.sku = res.data.model.sku[0];
          }
          self.form.model.product_status = res.data.model.product_status.value;

        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*转JSON字符串*/
    convertJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.product_equity;
      });
      return JSON.stringify(obj);
    },
    /*转JSON字符串*/
    convertMoneyJson(list){
      let obj={};
      let obj1={};
      let obj2={};
      let arr ={};
      list.forEach(item=>{
        obj[item.grade_id]=item.first_money;
        obj1[item.grade_id]=item.second_money;
        obj2[item.grade_id]=item.third_money;
      });
      arr['first_money'] = obj;
      arr['second_money'] = obj1;
      arr['third_money'] = obj2;
      return JSON.stringify(arr);
    },
    /*转JSON字符串*/
    convertEnableJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.push;
      });
      return JSON.stringify(obj);
    },
    /*提交*/
    onSubmit: function() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          let params = formatModel(self.model, self.form.model);
          params.is_hot = params.is_hot ? 1: 0;
          params.is_recommend = params.is_recommend ? 1: 0;
          params.is_new = params.is_new ? 1: 0;
          params.scene = self.scene;
          params.image = self.ImgKeepId(params.image);
          params.product_id = self.product_id;
          params.active =JSON.stringify(params.active);
          params.alone_grade_equity=self.convertJson(self.form.gradeList);
          params.alone_money_equity=self.convertMoneyJson(self.form.gradeList);
          params.alone_enable_grade_equity=self.convertEnableJson(self.form.gradeList);
          self.save_loading = true;
          PorductApi.editProduct({
             product_id: self.product_id,
             scene: self.scene,
             params: JSON.stringify(params)
          }, true)
            .then(data => {
              self.save_loading = false;
              self.$message({
                message: '保存成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.save_loading = false;
            });
        }
      });
    },

    /*图片数值只保留id*/
    ImgKeepId(list) {
      let arr = [];
      for (let i = 0, length = list.length; i < length; i++) {
        let obj = {
          image_id: list[i].image_id,
          file_id: list[i].file_id
        };
        arr.push(obj);
      }
      return arr;
    },

    /*保存为草稿*/
    Draft() {
      let self = this;
      self.form.model.product_status = 30;
      self.onSubmit();
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/edit.vue